var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"audio-playing-btn-component",on:{"click":_vm.handleClick}},[_c('ym-img',{staticClass:"img",attrs:{"src":_vm.src,"alt":"播放图片"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }